import { useLocation } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import { useAuth } from '../hooks/useAuth';
import { useEnvironment } from '../contexts/EnvironmentContext';

const Header = ({ title = 'Dashboard' }) => {
  const { user, logout } = useAuth();
  const { authState } = useOktaAuth();
  const location = useLocation();
  const { environments, selectedEnvironmentId, setSelectedEnvironmentId } = useEnvironment();

  // Prefer Okta id-token claims for human-facing display values; fall back to
  // the local user row from `/api/me` so we still render something on the
  // brief gap between Okta auth resolving and `/api/me` returning.
  const idClaims = authState?.idToken?.claims || {};
  const email = idClaims.email || user?.email || '';
  const displayName =
    idClaims.name ||
    idClaims.preferred_username ||
    user?.username ||
    (email ? email.split('@')[0] : '');
  const avatarInitial = (email || displayName || '?').charAt(0).toUpperCase();

  return (
    <header className="app-header">
      <div className="header-left">
        <h1 className="header-title">{title}</h1>
      </div>

      <div className="header-right">
        {/* Environment (production) dropdown - commented out
        {location.pathname === '/dashboard' && environments.length > 0 && (
          <div className="dropdown-wrapper">
            <select 
              className="header-btn environment-select"
              value={selectedEnvironmentId || ''}
              onChange={(e) => setSelectedEnvironmentId(parseInt(e.target.value))}
            >
              {environments.map((env) => (
                <option key={env.id} value={env.id}>
                  {env.name}
                </option>
              ))}
            </select>
          </div>
        )}
        */}

        {/* Date range / calendar - commented out
        {location.pathname === '/dashboard' && (
          <button className="header-btn date-range-btn">
            <svg width="18" height="18" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd"/>
            </svg>
            <div className="date-range-text">
              <span className="date-range-label">Past 90 days</span>
              <span className="date-range-dates">Aug 21 - Nov 19</span>
            </div>
            <svg width="16" height="16" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd"/>
            </svg>
          </button>
        )}
        */}

        {/* Notifications / alarm - commented out
        <button className="header-btn icon-btn" title="Notifications">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
            <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z"/>
          </svg>
        </button>
        */}

        {/* User identity — avatar-only, identity surfaces in a hover tooltip */}
        <div className="user-identity">
          <div
            className="user-avatar-wrapper"
            title={
              displayName
                ? `${displayName}${email ? ` (${email})` : ''}${
                    user?.role === 'admin' ? ' — Admin' : ''
                  }`
                : email
            }
          >
            <div className="user-avatar" aria-hidden="true">
              {avatarInitial}
            </div>
            <div className="user-avatar-tooltip" role="tooltip">
              {displayName && (
                <div className="user-avatar-tooltip-name">{displayName}</div>
              )}
              {email && (
                <div className="user-avatar-tooltip-email">{email}</div>
              )}
              {user?.role === 'admin' && (
                <div className="user-avatar-tooltip-role">Admin</div>
              )}
            </div>
          </div>
          <button
            type="button"
            className="user-signout-link"
            onClick={logout}
          >
            Sign out
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;

